import "./PujaPackageInfoView.scss";
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

import {
  Box,
  Grid,
  Stack,
  Typography,
  Button,
  Dialog,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
} from "@mui/material";
import ParagraphTypography from "../../components/typography/ParagraphTypography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import SubtitleTypography from "../../components/typography/SubtitleTypography";
import SubtitleTypographyPrimary from "../../components/typography/SubtitleTypographyPrimary";
import {
  getCityStateFromTemple,
  getTempleNameById,
} from "../../utils/HelperFunctions";
import { useEffect, useRef, useState } from "react";

import "react-responsive-carousel/lib/styles/carousel.min.css";

import Carousel from "react-multi-carousel";

import {
  CAROUSEL_REMOVE_ARRAOW_ON_DEVICE,
  LOCALSTORAGE_KEY,
  PUJA_PACKAGE_SCROLL_RESPONSIVE,
  DEVOTEE_EXPERIENCE_CAROUSEL,
  PUJALOADIMG,
  orderType,
  pujaPackageSections,
} from "../../utils/Constants";
import AlertDialog from "../../components/dialog/AlertDialog";
import { LOCALIZATION } from "../../utils/localization";
import TestimonialCard from "../../components/card/Testimonial/TestimonialCard";
import { pujaSections } from "../../utils/Constants";
import BannerCarouselWithVideo from "../../components/ServiceInfoDetailsTop/BannerCarouselWithVideo";
import ImageView from "../../components/ImageView/ImageView";
import PackagePujaService from "../../components/ServiceInfoDetailsTop/PackagePujaService";
import PujaSubscriptionCard from "../../components/pujaSubscriptionCard/PujaSubscriptionCard";
import ShowMoreShowLess from "../../components/ShowMoreShowLess/ShowMoreShowLess";
import SingleChadavaPackageItem from "../../components/SingleChadavaPackage/SingleChadavaPackageItem";
import PackageItemsDetailsDialog from "../../components/dialog/PackageItemsDetailsDialog";
import TrustedLogo from "../../components/trustedLogo/TrustedLogo";
import VideoCard from "../../components/card/videoCard/VideoCard";

function PujaPackageInfoView(props: any) {
  const { t, i18n } = useTranslation();
  const tabRefs = useRef<any>({});
  const {
    selectedTempleDetails,
    pujaDetails,
    cartInfo,
    setPopupPujaAlreadyAdded,
    preprocessingAndProceedToAddmemberScreen,
    navigateToSeeVideoView,
    navigateToPujaStepsView,
    popupPujaAlreadyAdded,
    currencySymbols,
    isCountryDisabledForBooking,
    userReview,
    itemAddLimitPopUp,
    setItemAddLimitPopUp,
    pujaSubscriptionPrice,
    pujaPackagePrice,
    pujaPriceInfo,
    onClickAddPuja,
    selectedPlan,
    handlePujaPlanChange,
    isOverseas,
    isOnlySubscriptionEnable,
    pujaPackagePreviewVideos,
  } = props;

  const [subHeader, setSubHeader] = useState([...pujaPackageSections]);
  const [selectedPujaPackage, setSelectedPujaPackage] = useState<any>(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [activeVideoUrl, setActiveVideoUrl] = useState<number | null>(null);

  useEffect(() => {
    if (pujaDetails?.id) {
      let updatedHeader = [...pujaPackageSections];

      if (!pujaDetails?.isSubscriptionEnable) {
        updatedHeader = updatedHeader.filter(
          (item) =>
            item.id !== "Subscription-Overview" &&
            item.id !== "Subscribe-and-Save"
        );
      } else {
        const hasSubscribeAndSave = updatedHeader.some(
          (item) => item.id === "Subscribe-and-Save"
        );
        if (!hasSubscribeAndSave) {
          updatedHeader.unshift({
            id: "Subscribe-and-Save",
            label: t("Subscribe_and_Save"),
          });
        }

        const hasSubscriptionOverview = updatedHeader.some(
          (item) => item.id === "Subscription-Overview"
        );

        if (!hasSubscriptionOverview) {
          updatedHeader.splice(2, 0, {
            id: "Subscription-Overview",
            label: "Subscription_Overview",
          });
        } else {
          const subIndex = updatedHeader.findIndex(
            (item) => item.id === "Subscription-Overview"
          );
          if (subIndex !== 2) {
            const [subOverview] = updatedHeader.splice(subIndex, 1);
            updatedHeader.splice(2, 0, subOverview);
          }
        }
      }

      const hasPackageDescription = !!pujaDetails?.packageDescription?.trim();
      const hasPackageImage = !!pujaDetails?.packageDetailsImage?.pictureUrl;
      const showPackageOverview = hasPackageDescription && hasPackageImage;

      const hasPackageOverview = updatedHeader.some(
        (item) => item.id === "Package-Overview"
      );

      if (showPackageOverview) {
        if (!hasPackageOverview) {
          updatedHeader.splice(3, 0, {
            id: "Package-Overview",
            label: "Package_Overview",
          });
        } else {
          const pkgIndex = updatedHeader.findIndex(
            (item) => item.id === "Package-Overview"
          );
          if (pkgIndex !== 3) {
            const [pkgOverview] = updatedHeader.splice(pkgIndex, 1);
            updatedHeader.splice(3, 0, pkgOverview);
          }
        }
      } else {
        updatedHeader = updatedHeader.filter(
          (item) => item.id !== "Package-Overview"
        );
      }
      const hasPujaPreviewVideos = pujaPackagePreviewVideos?.length > 0;

      const hasPujaPreviewSection = updatedHeader.some(
        (item) => item.id === "puja-video-preview"
      );
      const faqIndex = updatedHeader.findIndex((item) => item.id === "FAQ");

      if (hasPujaPreviewVideos) {
        if (!hasPujaPreviewSection) {
          const newSection = {
            id: "puja-video-preview",
            label: "The_Temple_Dekho_Promise",
          };
          if (faqIndex !== -1) {
            updatedHeader.splice(faqIndex, 0, newSection);
          } else {
            updatedHeader.push(newSection);
          }
        } else {
          const videoIndex = updatedHeader.findIndex(
            (item) => item.id === "puja-video-preview"
          );

          if (faqIndex !== -1 && videoIndex !== faqIndex - 1) {
            const [videoSection] = updatedHeader.splice(videoIndex, 1);
            updatedHeader.splice(faqIndex, 0, videoSection);
          }
        }
      } else {
        updatedHeader = updatedHeader.filter(
          (item) => item.id !== "puja-video-preview"
        );
      }

      setSubHeader(updatedHeader);
    }
  }, [
    pujaDetails?.id,
    pujaDetails?.isSubscriptionEnable,
    pujaDetails?.packageDescription,
    pujaDetails?.packageDetailsImage?.pictureUrl,
    pujaPackagePreviewVideos?.length,
  ]);

  useEffect(() => {
    const buttonId = "back-to-top";
    const hideBackToTop = () => {
      const btn = document.getElementById(buttonId);
      if (btn) {
        btn.style.display = "none";
      }
    };
    const handleScroll = () => {
      hideBackToTop();
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      const btn = document.getElementById(buttonId);
      if (btn) {
        btn.style.display = "";
      }
    };
  }, []);

  const savedLanguage =
    localStorage.getItem(LOCALSTORAGE_KEY.LANG_CODE) ?? "en";

  const getImageForBenefitsDataByBenefitId = (benefitId: string) => {
    const benefitList = props.benefitsList;
    const benefitFilterData = benefitList.filter(function (item: any) {
      return item.benefitId === benefitId;
    });
    if (benefitList.length > 0) {
      return benefitFilterData[0];
    } else {
      return null;
    }
  };

  const [
    openAlertDialogForBookingNotAllowed,
    setOpenAlertDialogForBookingNotAllowed,
  ] = useState<any>(false);

  const [urlToShare, setUrlToShare] = useState<string>("");
  const [activeSection, setActiveSection] = useState("aboutPuja");

  useEffect(() => {
    const hostname = window.location.hostname.includes("localhost")
      ? "http://localhost:3000"
      : "https://" + window.location.hostname;
    if (pujaDetails?.id) {
      setUrlToShare(
        `${hostname}/pagelink?pujaPackageNameKey=${pujaDetails?.pujaNameKey}`
      );
    }
  }, [pujaDetails]);

  useEffect(() => {
    if (activeSection && tabRefs.current[activeSection]) {
      tabRefs.current[activeSection].scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [activeSection]);

  useEffect(() => {
    const handleScrollSpy = () => {
      const scrollY = window.scrollY;
      for (let i = 0; i < pujaSections.length; i++) {
        const section = document.getElementById(pujaSections[i].id);
        if (section) {
          const offsetTop = section.offsetTop - 130;
          const offsetBottom = offsetTop + section.offsetHeight;
          if (scrollY >= offsetTop && scrollY < offsetBottom) {
            setActiveSection(pujaSections[i].id);
            break;
          }
        }
      }
    };

    window.addEventListener("scroll", handleScrollSpy);
    return () => window.removeEventListener("scroll", handleScrollSpy);
  }, []);

  const pujaBgImage =
    pujaDetails && pujaDetails.pujaBg && pujaDetails.pujaBg.uri
      ? pujaDetails.pujaBg.uri
      : PUJALOADIMG;

  const bookPujaPackage = () => {
    if (isCountryDisabledForBooking) {
      setOpenAlertDialogForBookingNotAllowed(true);
      return;
    }
    if (cartInfo && cartInfo.length > 0) {
      setPopupPujaAlreadyAdded(true);
    } else {
      preprocessingAndProceedToAddmemberScreen();
    }
    preprocessingAndProceedToAddmemberScreen();
  };

  const handleCloseAlertDialogForBookingNotAllowed = () => {
    setOpenAlertDialogForBookingNotAllowed(false);
  };

  const [expanded, setExpanded] = useState<string | false>("panel1");
  const handleChange1 =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  const isPujaBookingClosed = () => {
    return pujaDetails?.isPujaDisable;
  };

  const [isAboveFooter, setIsAboveFooter] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const footer = document.querySelector(".footerArea");
      const button = document.querySelector(".sticky-button");
      if (footer && button) {
        const footerRect = footer.getBoundingClientRect();
        const buttonRect = button.getBoundingClientRect();
        if (
          footerRect.top < window.innerHeight &&
          footerRect.bottom >= buttonRect.bottom
        ) {
          setIsAboveFooter(true);
        } else {
          setIsAboveFooter(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleScrollToSection = (id: string) => {
    const section = document.getElementById(id);
    if (section) {
      const yOffset = -120; // adjust this based on header height
      const y =
        section.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
      setActiveSection(id);
    }
  };

  const pujaImageArr =
    pujaDetails?.multiPujaImg && pujaDetails?.multiPujaImg.length
      ? pujaDetails.multiPujaImg.map((_itm: any) => {
          if (_itm?.pictureUrl) {
            return { pictureUrl: _itm.pictureUrl };
          } else if (_itm?.videoUrl) {
            return { videoUrl: _itm.videoUrl };
          } else {
            return { pictureUrl: PUJALOADIMG };
          }
        })
      : [{ pictureUrl: pujaBgImage }];

  const isReviewSingle = userReview?.length === 1 ? true : false;

  const packageList = pujaDetails?.packageItems
    ? Object.values(pujaDetails?.packageItems)
    : [];

  const getTempleNameByPackageId = (orgId: string): string => {
    if (!orgId) return "Unknown Temple";

    const temple = pujaDetails?.templeList?.[orgId]
      ? pujaDetails.templeList?.[orgId]
      : null;

    return temple?.personalInfo?.name ?? "Unknown Temple";
  };

  const handleOpenDialog = (pkg: any, templeName: any, templeAddress: any) => {
    setSelectedPujaPackage({ ...pkg, templeName, templeAddress });
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setSelectedPujaPackage(null);
  };

  const isDoubleVideoItem = pujaPackagePreviewVideos?.length <= 2;
  const handleAfterChange = (currentIndex: number) => {
    setActiveVideoUrl(currentIndex);
  };

  return (
    <Box className="pageContainer pujaPage">
      <Box className="pujaBlock">
        <Grid container spacing={1}>
          <Grid
            item
            xs={12}
            md={2}
            lg={2}
            xl={2}
            className="pagehdLeftBlock"
          ></Grid>
          <Grid item xs={12} md={8} lg={8} xl={8}>
            <Box className="pujainfoCenterBlock">
              <Box className="pujaCard">
                <Grid className="pujaCardBlock" container spacing={2}>
                  <Grid item xs={12} sm={12} md={12} lg={6}>
                    <BannerCarouselWithVideo imageArray={pujaImageArr} />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={6}>
                    <PackagePujaService
                      pujaName={pujaDetails?.pujaName}
                      finalPrice={
                        isOverseas
                          ? pujaPriceInfo?.finalPriceOv
                          : pujaPriceInfo?.finalPrice
                      }
                      offerActualPrice={
                        isOverseas
                          ? pujaPriceInfo?.offerActualPriceOv
                          : pujaPriceInfo?.offerActualPrice
                      }
                      itemOrderType={orderType?.pujaPackage}
                      urlToShare={urlToShare}
                      tithiName={pujaDetails?.tithiName}
                      description={pujaDetails?.description}
                      currencySymbol={currencySymbols}
                    />
                  </Grid>
                </Grid>
                {isPujaBookingClosed() && (
                  <ListItemText sx={{ color: "red" }}>
                    {t(LOCALIZATION.Pooja_Booking_Closed)}
                  </ListItemText>
                )}

                <Box
                  className="continueBtn desktopOnly sticky-button"
                  sx={{ position: `${isAboveFooter ? "absolute" : "fixed"}` }}
                >
                  <Stack
                    direction="row"
                    spacing={2}
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    {/* Price Section */}

                    <Box display="flex" alignItems="center" gap={2}>
                      <Typography
                        className="pujaPriceText"
                        sx={{ fontWeight: "bold" }}
                      >
                        {currencySymbols}
                        {isOverseas
                          ? pujaPriceInfo?.finalPriceOv ?? 0
                          : pujaPriceInfo?.finalPrice ?? 0}
                      </Typography>

                      {((!isOverseas && pujaPriceInfo?.offerActualPrice > 0) ||
                        (isOverseas &&
                          pujaPriceInfo?.offerActualPriceOv > 0)) && (
                        <Typography
                          variant="body2"
                          sx={{
                            textDecoration: "line-through",
                            color: "#E5C765",
                          }}
                        >
                          {currencySymbols}{" "}
                          {isOverseas
                            ? pujaPriceInfo?.offerActualPriceOv ?? 0
                            : pujaPriceInfo?.offerActualPrice ?? 0}
                        </Typography>
                      )}
                    </Box>

                    <Button
                      className="desktopContinueBtn"
                      variant="contained"
                      onClick={() => {
                        bookPujaPackage();
                      }}
                      disabled={isPujaBookingClosed()}
                    >
                      {isPujaBookingClosed()
                        ? t(LOCALIZATION.Pooja_Booking_Closed)
                        : t(LOCALIZATION.Continue_to_Book)}
                    </Button>
                  </Stack>
                </Box>
              </Box>

              <Box className="pujaInfoContainer">
                <nav className="pujaTabsNav-container">
                  <Stack
                    direction="row"
                    spacing={5}
                    className="pujaTabsScroll itemCenter"
                  >
                    {subHeader.map((sec: any) => (
                      <span
                        key={sec.id}
                        className={`pujaTab ${
                          activeSection === sec.id ? "pujaTabActive" : ""
                        }`}
                        onClick={() => handleScrollToSection(sec.id)}
                        ref={(el) => (tabRefs.current[sec.id] = el)}
                      >
                        {t(sec.label)}
                      </span>
                    ))}
                  </Stack>
                </nav>
                {pujaDetails?.isSubscriptionEnable && (
                  <Box className="chadhavaPlanArea" id="Subscribe-and-Save">
                    <SubtitleTypographyPrimary
                      className="planAreaTitleuui"
                      title={t(LOCALIZATION.Subscribe_and_Save)}
                    ></SubtitleTypographyPrimary>

                    <Box className="planList">
                      {pujaDetails?.subscriptions?.map((plan: any) => {
                        const priceInfo = pujaSubscriptionPrice?.[0];
                        return (
                          <PujaSubscriptionCard
                            key={plan?.id}
                            id={plan?.id}
                            name={plan?.name}
                            duration={plan?.frequency}
                            type={plan.type}
                            description={plan.description}
                            finalPrice={
                              isOverseas
                                ? priceInfo?.finalPriceOv ?? 0
                                : priceInfo?.finalPrice ?? 0
                            }
                            offerActualPrice={
                              isOverseas
                                ? priceInfo?.offerActualPriceOv ?? 0
                                : priceInfo?.offerActualPrice ?? 0
                            }
                            currencySymbol={currencySymbols}
                            onSelect={(id: any) =>
                              handlePujaPlanChange(id, priceInfo)
                            }
                            selected={selectedPlan?.id === plan.id}
                            subscriptionImage={
                              plan?.subscriptionImage?.pictureUrl
                            }
                            isOnlySubscriptionEnable={
                              isOnlySubscriptionEnable ?? false
                            }
                          />
                        );
                      })}
                    </Box>
                  </Box>
                )}
                {pujaDetails?.isSubscriptionEnable && (
                  <Divider
                    className="divider"
                    sx={{
                      borderBottom: "3px solid #fff",
                      paddingTop: "0.8rem",
                    }}
                  />
                )}
                <Box className="packageoverViewText" mb={1} id="Puja-Package">
                  <SubtitleTypographyPrimary
                    title={t(LOCALIZATION.Item_Included_In_This_Puja_Package)}
                  ></SubtitleTypographyPrimary>
                </Box>

                <Box className="productCardCarousel">
                  {packageList?.length > 0 && (
                    <Carousel
                      responsive={PUJA_PACKAGE_SCROLL_RESPONSIVE}
                      swipeable
                      draggable
                      showDots
                      infinite
                      keyBoardControl
                      containerClass="carousel-container"
                      itemClass="carousel-item-padding-40"
                      removeArrowOnDeviceType={CAROUSEL_REMOVE_ARRAOW_ON_DEVICE}
                    >
                      {packageList.map((pkg: any) => {
                        const templeName = getTempleNameById(
                          pujaDetails?.templeList,
                          pkg?.orgId
                        );

                        const personalInfo =
                          pujaDetails?.templeList?.[pkg?.orgId]?.personalInfo ||
                          {};

                        const templeAddress =
                          getCityStateFromTemple(personalInfo);

                        return (
                          <div
                            key={pkg?.id}
                            style={{ cursor: "pointer" }}
                            // onClick={() => onClickAddPuja({ pujaDetails: pkg })}
                            onClick={() =>
                              handleOpenDialog(pkg, templeName, templeAddress)
                            }
                          >
                            <SingleChadavaPackageItem
                              packageImage={
                                pkg.multiPujaImg?.[1]?.pictureUrl ??
                                pkg.pujaBg?.uri ??
                                ""
                              }
                              packageName={pkg?.pujaName}
                              templeName={templeName}
                              templeAddress={templeAddress}
                            />
                          </div>
                        );
                      })}
                    </Carousel>
                  )}
                </Box>

                {pujaDetails?.isSubscriptionEnable && (
                  <Divider
                    className="divider"
                    sx={{
                      borderBottom: "3px solid #fff",
                      paddingTop: "0.8rem",
                    }}
                  />
                )}
                {pujaDetails?.isSubscriptionEnable && (
                  <Box
                    className="packageDescription"
                    id="Subscription-Overview"
                  >
                    <Box className="mainTitle">
                      <SubtitleTypographyPrimary
                        title={t(LOCALIZATION.Subscription_Overview)}
                      />
                    </Box>

                    <Grid container spacing={2}>
                      {pujaDetails?.subscriptions?.map(
                        (subscription: any, index: number) => (
                          <>
                            <Grid item xs={12} md={6}>
                              {subscription?.subscriptionImage?.pictureUrl && (
                                <Box className="packageCardImg">
                                  <ImageView
                                    src={
                                      subscription.subscriptionImage
                                        .pictureUrl || ""
                                    }
                                    alt={`Subscription Image ${index + 1}`}
                                  />
                                </Box>
                              )}
                            </Grid>
                            <Grid item xs={12} md={6}>
                              {subscription?.description && (
                                <Box className="bottomDescription">
                                  <ShowMoreShowLess
                                    text={subscription.description}
                                    mode="line"
                                    lines={2}
                                    // limit={200}
                                  />
                                </Box>
                              )}
                            </Grid>
                          </>
                        )
                      )}
                    </Grid>
                  </Box>
                )}
                <Divider
                  className="divider"
                  sx={{
                    borderBottom: "3px solid #fff",
                    paddingTop: "0.8rem",
                  }}
                />

                {pujaDetails?.packageDescription?.trim() &&
                  pujaDetails?.packageDetailsImage?.pictureUrl &&
                  !isOnlySubscriptionEnable && (
                    <Box className="packageDescription" id="Package-Overview">
                      <Box className="mainTitle">
                        <SubtitleTypographyPrimary
                          title={t(LOCALIZATION.Package_Overview)}
                        />
                      </Box>

                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <Box className="packageCardImg">
                            <ImageView
                              src={pujaDetails.packageDetailsImage.pictureUrl}
                              alt="Puja overview Image"
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Box className="bottomDescription">
                            <ShowMoreShowLess
                              text={pujaDetails.packageDescription}
                              limit={200}
                            />
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                  )}
                {!isOnlySubscriptionEnable &&
                  pujaDetails?.packageDescription &&
                  pujaDetails?.packageDetailsImage?.pictureUrl && (
                    <Divider
                      className="divider"
                      sx={{
                        borderBottom: "3px solid #fff",
                        paddingTop: "0.8rem",
                      }}
                    />
                  )}

                <Box className="pujaBenefits" id="puja-benefits">
                  <SubtitleTypographyPrimary
                    title={t(LOCALIZATION.Benefits_of_this_Puja)}
                  ></SubtitleTypographyPrimary>
                  {pujaDetails &&
                    pujaDetails.benefitList &&
                    pujaDetails.benefitList.map((item: any) => {
                      let updatedBenefitsData = item;
                      const benefitDetais = getImageForBenefitsDataByBenefitId(
                        item.benefitId
                      );

                      if (benefitDetais) {
                        updatedBenefitsData = benefitDetais;
                      }
                      return (
                        <Box
                          className="benefitsCard"
                          key={updatedBenefitsData?.name}
                        >
                          <SubtitleTypography
                            title={`${updatedBenefitsData.name}`}
                          ></SubtitleTypography>
                          <Box className="benefitCardImg">
                            <ImageView
                              src={`${updatedBenefitsData.url}`}
                              alt="Benefit Image"
                            />
                          </Box>
                          <ParagraphTypography
                            title={`${updatedBenefitsData.description}`}
                          ></ParagraphTypography>
                        </Box>
                      );
                    })}
                </Box>

                <Box className="pujaProccessSteps" id="quick-steps">
                  <SubtitleTypographyPrimary
                    title={t(LOCALIZATION.puja_package_stapes)}
                  ></SubtitleTypographyPrimary>
                  <List>
                    <ListItem>
                      <ListItemText
                        primary={
                          <Box className="listCounter">
                            <Typography
                              component="span"
                              className="pujaStepsListCount"
                            >
                              1
                            </Typography>

                            <Typography>
                              {t(LOCALIZATION.Select_your_Puja_Package)}
                            </Typography>
                          </Box>
                        }
                      />
                    </ListItem>
                    <ListItem>
                      <ListItemText
                        primary={
                          <Box className="listCounter">
                            <Typography
                              component="span"
                              className="pujaStepsListCount"
                            >
                              2
                            </Typography>

                            <Typography>
                              {t(LOCALIZATION.Enter_your_details_puja)}
                            </Typography>
                          </Box>
                        }
                      />
                    </ListItem>
                    <ListItem>
                      <ListItemText
                        primary={
                          <Box className="listCounter">
                            <Typography
                              component="span"
                              className="pujaStepsListCount"
                            >
                              3
                            </Typography>

                            <Typography>
                              {t(LOCALIZATION.Add_your_prasad_delivery)}
                            </Typography>
                          </Box>
                        }
                      />
                    </ListItem>
                    <ListItem>
                      <ListItemText
                        primary={
                          <Box className="listCounter">
                            <Typography
                              component="span"
                              className="pujaStepsListCount"
                            >
                              4
                            </Typography>

                            <Typography>
                              {t(LOCALIZATION.Complete_secure_payment)}
                            </Typography>
                          </Box>
                        }
                      />
                    </ListItem>
                    <ListItem>
                      <ListItemText
                        primary={
                          <Box className="listCounter">
                            <Typography
                              component="span"
                              className="pujaStepsListCount"
                            >
                              5
                            </Typography>

                            <Typography>
                              {t(LOCALIZATION.Get_updates_and_puja)}
                            </Typography>
                          </Box>
                        }
                      />
                    </ListItem>
                    <ListItem>
                      <ListItemText
                        primary={
                          <Box className="listCounter">
                            <Typography
                              component="span"
                              className="pujaStepsListCount"
                            >
                              6
                            </Typography>

                            <Typography>
                              {t(LOCALIZATION.Receive_prasad_within)}
                            </Typography>
                          </Box>
                        }
                      />
                    </ListItem>
                  </List>
                </Box>
                {/* Devotee Experience */}
                {userReview?.length > 0 ? (
                  <Box
                    className="testimonial carouselArrowColor"
                    id="devotee-experience"
                  >
                    <SubtitleTypographyPrimary
                      title={t(LOCALIZATION.Devotee_Experience)}
                    ></SubtitleTypographyPrimary>
                    <Carousel
                      responsive={DEVOTEE_EXPERIENCE_CAROUSEL}
                      swipeable={true}
                      draggable={true}
                      showDots={true}
                      keyBoardControl={true}
                      removeArrowOnDeviceType={CAROUSEL_REMOVE_ARRAOW_ON_DEVICE}
                      className={`testimonialCarousel ${
                        isReviewSingle ? "singleItem" : ""
                      }`}
                    >
                      {userReview?.map((_item: any) => {
                        return (
                          <TestimonialCard
                            key={_item?.id}
                            reviewData={_item}
                            pujaDetails={pujaDetails}
                            selectedTempleDetails={selectedTempleDetails}
                          />
                        );
                      })}
                    </Carousel>
                  </Box>
                ) : null}
                {/* "Puja_Contribution_Details" */}
                <Box
                  className="PujaContribution"
                  id="Puja-Contribution-Details"
                  sx={{ mt: 4 }}
                >
                  <SubtitleTypographyPrimary
                    title={t(LOCALIZATION.Puja_Contribution_Details)}
                  />
                  <Typography variant="body1" sx={{ mt: 1 }}>
                    {t(
                      LOCALIZATION.Your_gracious_contribution_for_this_sacred_puja_offering
                    )}
                  </Typography>
                  <Typography variant="body1" sx={{ mt: 1 }}>
                    {t(
                      LOCALIZATION.We_express_our_heartfelt_gratitude_for_your_participation
                    )}
                  </Typography>
                </Box>

                {pujaPackagePreviewVideos.length > 0 && (
                  <Box
                    className="pujaVideoPreview carouselArrowColor"
                    id="puja-video-preview"
                  >
                    <SubtitleTypographyPrimary
                      title={t(LOCALIZATION.The_Temple_Dekho_Promise)}
                    />
                    <Typography variant="body1" mt={1}>
                      {t(LOCALIZATION.Promise_Video_Description)}
                    </Typography>

                    <Box mt={3}>
                      {Array.isArray(pujaPackagePreviewVideos) &&
                        pujaPackagePreviewVideos?.length > 0 && (
                          <Carousel
                            responsive={DEVOTEE_EXPERIENCE_CAROUSEL}
                            swipeable
                            draggable
                            showDots
                            keyBoardControl
                            autoPlaySpeed={4000}
                            infinite
                            removeArrowOnDeviceType={
                              CAROUSEL_REMOVE_ARRAOW_ON_DEVICE
                            }
                            className={`pujaVideoCarousel ${
                              isDoubleVideoItem ? "singleItem" : ""
                            }`}
                            afterChange={handleAfterChange}
                            pauseOnHover={false}
                          >
                            {pujaPackagePreviewVideos?.map(
                              (video: any, index: number) => (
                                <VideoCard
                                  key={video?.videoUrl}
                                  videoUrl={video?.videoUrl}
                                  isPlaying={activeVideoUrl === index}
                                  onClickPlay={(isPlay: boolean) => {
                                    if (isPlay) {
                                      setActiveVideoUrl(index);
                                    } else {
                                      setActiveVideoUrl(null);
                                    }
                                  }}
                                  showVideoDescription={
                                    video?.showVideoDescription ?? ""
                                  }
                                />
                              )
                            )}
                          </Carousel>
                        )}
                    </Box>
                  </Box>
                )}

                {/* FAQ */}
                <Box className="chadhavaFaq" id="faq">
                  <SubtitleTypographyPrimary
                    title={t(LOCALIZATION.Frequently_Asked_Questions)}
                  ></SubtitleTypographyPrimary>
                  <Box className="chadhavaFaqList">
                    <Accordion
                      className="accordionInfo"
                      expanded={expanded === "panel1"}
                      onChange={handleChange1("panel1")}
                      sx={{
                        "&.Mui-expanded::before": {
                          opacity: 1,
                        },
                      }}
                    >
                      <AccordionSummary
                        expandIcon={
                          <ExpandMoreIcon
                            sx={{
                              color: expanded === "panel1" ? "#d56939" : "#000",
                              transform:
                                expanded === "panel1"
                                  ? "rotate(180deg)"
                                  : "rotate(270deg)",
                              transition: "transform 0.3s ease",
                            }}
                          />
                        }
                        aria-controls="panel1-content"
                        id="panel1-header"
                        sx={{
                          p: 0,
                          fontWeight: "600",
                        }}
                      >
                        {t(LOCALIZATION.What_is_Temple_Dekho_FAQ)}
                      </AccordionSummary>
                      <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                        {t(LOCALIZATION.What_is_Temple_Dekho_FAQ_Answer)}
                      </AccordionDetails>
                    </Accordion>

                    <Accordion
                      className="accordionInfo"
                      expanded={expanded === "panel2"}
                      onChange={handleChange1("panel2")}
                      sx={{
                        "&.Mui-expanded::before": {
                          opacity: 1,
                        },
                      }}
                    >
                      <AccordionSummary
                        expandIcon={
                          <ExpandMoreIcon
                            sx={{
                              color: expanded === "panel2" ? "#d56939" : "#000",
                              transform:
                                expanded === "panel2"
                                  ? "rotate(180deg)"
                                  : "rotate(270deg)",
                              transition: "transform 0.3s ease",
                            }}
                          />
                        }
                        aria-controls="panel2-content"
                        id="panel2-header"
                        sx={{
                          p: 0,
                          fontWeight: "600",
                        }}
                      >
                        {t(
                          LOCALIZATION.What_makes_your_virtual_puja_services_FAQ
                        )}
                      </AccordionSummary>
                      <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                        {t(
                          LOCALIZATION.What_makes_your_virtual_puja_services_FAQ_Answer
                        )}
                      </AccordionDetails>
                    </Accordion>

                    <Accordion
                      className="accordionInfo"
                      expanded={expanded === "panel3"}
                      onChange={handleChange1("panel3")}
                      sx={{
                        "&.Mui-expanded::before": {
                          opacity: 1,
                        },
                      }}
                    >
                      <AccordionSummary
                        expandIcon={
                          <ExpandMoreIcon
                            sx={{
                              color: expanded === "panel3" ? "#d56939" : "#000",
                              transform:
                                expanded === "panel3"
                                  ? "rotate(180deg)"
                                  : "rotate(270deg)",
                              transition: "transform 0.3s ease",
                            }}
                          />
                        }
                        aria-controls="panel3-content"
                        id="panel3-header"
                        sx={{
                          p: 0,
                          fontWeight: "600",
                        }}
                      >
                        {t(LOCALIZATION.How_do_you_prioritize_the_security_FAQ)}
                      </AccordionSummary>
                      <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                        {t(
                          LOCALIZATION.How_do_you_prioritize_the_security_FAQ_Answer
                        )}
                      </AccordionDetails>
                    </Accordion>

                    <Accordion
                      className="accordionInfo"
                      expanded={expanded === "panel4"}
                      onChange={handleChange1("panel4")}
                      sx={{
                        "&.Mui-expanded::before": {
                          opacity: 1,
                        },
                      }}
                    >
                      <AccordionSummary
                        expandIcon={
                          <ExpandMoreIcon
                            sx={{
                              color: expanded === "panel4" ? "#d56939" : "#000",
                              transform:
                                expanded === "panel4"
                                  ? "rotate(180deg)"
                                  : "rotate(270deg)",
                              transition: "transform 0.3s ease",
                            }}
                          />
                        }
                        aria-controls="panel4-content"
                        id="panel4-header"
                        sx={{
                          p: 0,
                          fontWeight: "600",
                        }}
                      >
                        {t(
                          LOCALIZATION.Who_is_designated_to_perform_my_Puja_FAQ
                        )}
                      </AccordionSummary>
                      <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                        {t(
                          LOCALIZATION.Who_is_designated_to_perform_my_Puja_FAQ_Answer
                        )}
                      </AccordionDetails>
                    </Accordion>

                    <Accordion
                      className="accordionInfo"
                      expanded={expanded === "panel5"}
                      onChange={handleChange1("panel5")}
                      sx={{
                        "&.Mui-expanded::before": {
                          opacity: 1,
                        },
                      }}
                    >
                      <AccordionSummary
                        expandIcon={
                          <ExpandMoreIcon
                            sx={{
                              color: expanded === "panel5" ? "#d56939" : "#000",
                              transform:
                                expanded === "panel5"
                                  ? "rotate(180deg)"
                                  : "rotate(270deg)",
                              transition: "transform 0.3s ease",
                            }}
                          />
                        }
                        aria-controls="panel5-content"
                        id="panel5-header"
                        sx={{
                          p: 0,
                          fontWeight: "600",
                        }}
                      >
                        {t(
                          LOCALIZATION.Can_I_participate_in_a_Puja_if_I_don_know_my_Gotram_FAQ
                        )}
                      </AccordionSummary>
                      <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                        {t(
                          LOCALIZATION.Can_I_participate_in_a_Puja_if_I_don_know_my_Gotram_FAQ_Answer
                        )}
                      </AccordionDetails>
                    </Accordion>

                    <Accordion
                      className="accordionInfo"
                      expanded={expanded === "panel6"}
                      onChange={handleChange1("panel6")}
                      sx={{
                        "&.Mui-expanded::before": {
                          opacity: 1,
                        },
                      }}
                    >
                      <AccordionSummary
                        expandIcon={
                          <ExpandMoreIcon
                            sx={{
                              color: expanded === "panel6" ? "#d56939" : "#000",
                              transform:
                                expanded === "panel6"
                                  ? "rotate(180deg)"
                                  : "rotate(270deg)",
                              transition: "transform 0.3s ease",
                            }}
                          />
                        }
                        aria-controls="panel6-content"
                        id="panel6-header"
                        sx={{
                          p: 0,
                          fontWeight: "600",
                        }}
                      >
                        {t(LOCALIZATION.How_do_I_get_evidence_of_my_Puja_FAQ)}
                      </AccordionSummary>
                      <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                        {t(
                          LOCALIZATION.How_do_I_get_evidence_of_my_Puja_FAQ_Answer
                        )}
                      </AccordionDetails>
                    </Accordion>

                    <Accordion
                      className="accordionInfo"
                      expanded={expanded === "panel7"}
                      onChange={handleChange1("panel7")}
                      sx={{
                        "&.Mui-expanded::before": {
                          opacity: 1,
                        },
                      }}
                    >
                      <AccordionSummary
                        expandIcon={
                          <ExpandMoreIcon
                            sx={{
                              color: expanded === "panel7" ? "#d56939" : "#000",
                              transform:
                                expanded === "panel7"
                                  ? "rotate(180deg)"
                                  : "rotate(270deg)",
                              transition: "transform 0.3s ease",
                            }}
                          />
                        }
                        aria-controls="panel7-content"
                        id="panel7-header"
                        sx={{
                          p: 0,
                          fontWeight: "600",
                        }}
                      >
                        {t(
                          LOCALIZATION.Who_should_I_reach_out_to_for_more_details_FAQ
                        )}
                      </AccordionSummary>
                      <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                        {t(
                          LOCALIZATION.Who_should_I_reach_out_to_for_more_details_FAQ_Answer
                        )}
                      </AccordionDetails>
                    </Accordion>

                    <Accordion
                      className="accordionInfo"
                      expanded={expanded === "panel8"}
                      onChange={handleChange1("panel8")}
                      sx={{
                        "&.Mui-expanded::before": {
                          opacity: 1,
                        },
                      }}
                    >
                      <AccordionSummary
                        expandIcon={
                          <ExpandMoreIcon
                            sx={{
                              color: expanded === "panel8" ? "#d56939" : "#000",
                              transform:
                                expanded === "panel8"
                                  ? "rotate(180deg)"
                                  : "rotate(270deg)",
                              transition: "transform 0.3s ease",
                            }}
                          />
                        }
                        aria-controls="panel8-content"
                        id="panel8-header"
                        sx={{
                          p: 0,
                          fontWeight: "600",
                        }}
                      >
                        {t(LOCALIZATION.How_do_I_receive_the_prasad_FAQ)}
                      </AccordionSummary>
                      <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                        {t(LOCALIZATION.How_do_I_receive_the_prasad_FAQ_Answer)}
                      </AccordionDetails>
                    </Accordion>
                  </Box>
                </Box>
              </Box>

              <TrustedLogo />

              <Box className="blessContinue">
                {/* <Box className="viewBless">
                  <img src={viewBless} alt="viewBless"></img>
                </Box> */}

                <Box className="continueCart">
                  <Box className="continueCenterBlock">
                    <Box display="flex" alignItems="center" gap={2}>
                      <Typography
                        className="pujaPriceText"
                        sx={{ color: "#fff", fontWeight: "bold" }}
                      >
                        {currencySymbols}
                        {isOverseas
                          ? pujaPriceInfo?.finalPriceOv ?? 0
                          : pujaPriceInfo?.finalPrice ?? 0}
                      </Typography>

                      {((!isOverseas && pujaPriceInfo?.offerActualPrice > 0) ||
                        (isOverseas &&
                          pujaPriceInfo?.offerActualPriceOv > 0)) && (
                        <Typography
                          variant="body2"
                          sx={{
                            textDecoration: "line-through",
                            color: "#E5C765",
                          }}
                        >
                          {currencySymbols}{" "}
                          {isOverseas
                            ? pujaPriceInfo?.offerActualPriceOv ?? 0
                            : pujaPriceInfo?.offerActualPrice ?? 0}
                        </Typography>
                      )}
                    </Box>
                    <Box className="continueRt">
                      <Button
                        type="button"
                        className="continueBtn"
                        disabled={isPujaBookingClosed()}
                        onClick={() => {
                          bookPujaPackage();
                        }}
                      >
                        {isPujaBookingClosed()
                          ? "Booking Closed"
                          : t(LOCALIZATION.Continue)}
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={2} lg={2} xl={2} className="pagehdRightBlock">
            {/* <RightBlockCard /> */}
          </Grid>
        </Grid>

        {/* <Dialog
          onClose={() => setPopupPujaAlreadyAdded(false)}
          open={popupPujaAlreadyAdded}
        >
          <Box style={{ padding: "1em" }}>
            <Typography>
              {t(LOCALIZATION.A_puja_already_added_in_your_cart)}
            </Typography>
            <Box sx={{ textAlign: "end" }}>
              <Button onClick={() => setPopupPujaAlreadyAdded(false)}>
                {t(LOCALIZATION.No)}
              </Button>
              <Button
                onClick={() => preprocessingAndProceedToAddmemberScreen()}
              >
                {t(LOCALIZATION.Yes)}
              </Button>
            </Box>
          </Box>
        </Dialog> */}

        <Dialog
          onClose={() => setItemAddLimitPopUp(false)}
          open={itemAddLimitPopUp}
        >
          <Box style={{ padding: "1em" }}>
            <Typography>{t(LOCALIZATION.Cart_Max_Limit_Message)}</Typography>
            <Box sx={{ textAlign: "end" }}>
              <Button onClick={() => setItemAddLimitPopUp(false)}>
                {t(LOCALIZATION.OK)}
              </Button>
            </Box>
          </Box>
        </Dialog>
      </Box>
      <AlertDialog
        open={openAlertDialogForBookingNotAllowed}
        onClose={handleCloseAlertDialogForBookingNotAllowed}
        message={t(
          LOCALIZATION.Prasad_Bookings_are_not_permitted_in_your_country
        )}
      />
      {selectedPujaPackage?.id && (
        <PackageItemsDetailsDialog
          open={dialogOpen}
          onClose={handleCloseDialog}
          packageImage={selectedPujaPackage?.pujaBg?.uri}
          templeName={selectedPujaPackage?.templeName}
          pujaName={selectedPujaPackage?.pujaName}
          packageDescription={selectedPujaPackage?.description}
          templeAddress={selectedPujaPackage?.templeAddress}
          onClickAddPuja={() =>
            onClickAddPuja({ pujaDetails: selectedPujaPackage })
          }
        />
      )}
    </Box>
  );
}

export default PujaPackageInfoView;
